import axios from 'axios'
import { getCookie } from '@/utils'

const getheaders = () => ({
	Accept: 'application/json',
	'X-Requested-With': 'XMLHttpRequest',
})

axios.defaults.baseURL = '/selena/participants/api/'

const post = (url, data, headers = {}) => {
	return axios
		.post(url, data, { headers: getheaders(), ...headers })
		.then((r) => r)
		.catch((err) => {
			if (err.response && err.response.status > 400) {
				alert('Oops! Some error occurred, Please try again later!')
			} else {
				return err.response
			}
		})
}

export const get = (url) => {
	return axios
		.get(url, { headers: getheaders() })
		.then((r) => r)
		.catch((err) => {
			console.log(err)
			alert('Oops! Some error occurred, Please try again later!')
		})
}

const put = (url, data, headers = {}) => {
	return axios
		.put(url, data, { headers: getheaders(), ...headers })
		.then((r) => r)
		.catch((err) => {
			if (err.response && err.response.status > 400) {
				alert('Oops! Some error occurred, Please try again later!')
			} else {
				return err.response
			}
		})
}

export const generateOTP = async (mobile) => {
	return post('generate-otp/', { mobile: mobile })
}

export const mobileLogin = ({ mobile, otp }) => {
	return post('mobile-login/', { mobile, otp })
}

export const verifyOTP = ({ mobile, otp }) => {
	return post('verify-otp/', { mobile, otp })
}

export const getStatesList = () => {
	return get('states-list/')
}

export const getCityListByState = (stateId) => {
	return get(`city-list/?state=${stateId}`)
}

export const getCollegeListByCity = (cityId) => {
	return get(`college-list/?city=${cityId}`)
}

export const statusCheck = () => {
	return get(`status-check/`)
}

export const updateParticipateInfo = (data) => {
	return post(`update-participant/`, data)
}

export const updateVideoWatched = () => {
	return post(`video-watched/`, {})
}

export const getQuizQuestions = () => {
	return get(`questions/`)
}

export const submitQuiz = (data) => {
	return post(`results/`, data)
}

export const getQuizScore = () => {
	return get(`results/`)
}

export const createProfile = (data) => {
	return post(`create-participant-profile/`, data)
}

export const getProducts = () => {
	return get(`products/`)
}
